import PropTypes from "prop-types"

import Row from "../../../common/components/Row"
import { adminLiquidToolbarSx } from "../adminStyles"
import AdminLiquidSurface from "./AdminLiquidSurface"

export default function AdminLiquidToolbar({ children, sx }) {
  return (
    <AdminLiquidSurface variant="panel" sx={{ ...adminLiquidToolbarSx, ...sx }}>
      <Row gap={2} flexWrap="wrap" sx={{ alignItems: "center" }}>
        {children}
      </Row>
    </AdminLiquidSurface>
  )
}

AdminLiquidToolbar.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
}
